import actions from './actions'
import mutations from './mutations'

const data = {
    state: {
        leaders: [],
        businesses: [],
        numberOfBusinesses: null,
        numberOfClients: null,
        numberOfUnconfirmedBusinesses: null,
        purchasePromoDialog: false
    },
    mutations,
    actions
}

export default data
